import { render, staticRenderFns } from "./Aceite.vue?vue&type=template&id=01014355"
import script from "./Aceite.vue?vue&type=script&lang=js"
export * from "./Aceite.vue?vue&type=script&lang=js"
import style0 from "./Aceite.vue?vue&type=style&index=0&id=01014355&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports